class Cookies {
    static get(name) {
        // Split cookie string and get all individual name=value pairs in an array
        const cookieArr = document.cookie.split(";");

        // Loop through the array elements
        for (var i = 0; i < cookieArr.length; i++) {
            const cookiePair = cookieArr[i].split("=");
            /* Removing whitespace at the beginning of the cookie name
            and compare it with the given string */
            if (name == cookiePair[0].trim()) {
                // Decode the cookie value and return
                return decodeURIComponent(cookiePair[1]);
            }
        }

        // Return null if not found
        return null;
    }

    static save(name, value, days, domain) {
        let expires = "";
        let cookieDomain = window.location.host;

        if (days) {
            var date = new Date();
            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
            expires = "; expires=" + date.toGMTString();
        }

        if (domain == undefined || domain == null) {
            const subDomainRegex = new RegExp(/^([a-z]+:\/{2})?([\w-]+\.[\w-]+\.\w+)$/)
            // eslint-disable-next-line no-extra-boolean-cast
            if (Boolean(window.location.host.match(subDomainRegex))) {
                cookieDomain = window.location.host.split(/\.(.+)/)[1];
            }
        } else {
            cookieDomain = domain;
        }
        document.cookie = name + "=" + value + expires + "; path=/; domain=" + cookieDomain;
    }

    static remove(name, domain) {
        Cookies.save(name, '', -1, domain);
    }

    static getJSON(name) {
        const cookie = this.get(name);

        if (cookie !== undefined) {
            return JSON.parse(cookie);
        }

        return null;
    }

    static saveJSON(name, value, days, domain) {
        // var val = JSON.stringify(value);
        var val = encodeURIComponent(JSON.stringify(value));
        this.save(name, val, days, domain);
    }
}

class CookieConsentApi {
    static cookieConsentKey = "CookieConsent";
    static cookieConsentDaysToExpire = 365;
    static cookieTrackFirstVisit = 'trackFirstVisit';

    /** @type {import('./def/CookieConsent').CookieConsentCookie} */
    static get() {
        let cookieValue = Cookies.getJSON(CookieConsentApi.cookieConsentKey);
        if (cookieValue === null) {
            const domainNoPort = window.location.host.replace(/:[0-9]+/gi, '');
            const isStyleGuide = domainNoPort === 'localhost';
            if (isStyleGuide) {

              // test data
              cookieValue = {
                  "cookie-consent":false,
                  "cookie-consent-key":"7",
                  "cookie-agents":null,
                  "cookies-timeout":"2052-08-27T09:17:11.844423+02:00",
                  "cookies-groups":[
                      {
                        "name":"nessesarycookies",
                        "approved":true,"neccesary":true
                      },
                      {
                          "name":"analyticalcookies",
                          "approved":false,
                          "neccesary":false
                      },
                      {
                          "name":"functionalcookies",
                          "approved":false,
                          "neccesary":false
                      }],
                      "domain": domainNoPort,
                };
            }
        }

        return cookieValue;
    }

    static getRaw() {
        const cookieValue = Cookies.get(CookieConsentApi.cookieConsentKey);

        return cookieValue;
    }

    static getStringWithoutPersonalData(val) {
        try {
            // Obfuscate Patterns
            const piiRegEx = [{
              name: 'EMAIL',
              regex: /[^/\s&?][a-zA-Z0-9._-]+(@|%40)(?!(agricard\.no|dinersclub\.dk|dinersclub\.fi|dinersclub\.no|dinersclub\.se|essomastercard\.no|eurocardbyinvitation\.dk|eurocardinternational\.com|eurocard\.com|eurocard\.dk|eurocard\.fi|eurocard\.no|globecard\.dk|partnermastercard\.com|saseurobonusmastercard\.dk|saseurobonusmastercard\.no|saseurobonusmastercard\.se|sebgroup\.com|sebkort\.com|seb\.se|wallethome\.com|spendwise\.se))[^/\s]+[a-zA-Z0-9._-]/gi
            }, {
              name: 'SELF-EMAIL',
              regex: /[^/\s&?][a-zA-Z0-9._-]+(@|%40)(?=(agricard\.no|dinersclub\.dk|dinersclub\.fi|dinersclub\.no|dinersclub\.se|essomastercard\.no|eurocardbyinvitation\.dk|eurocardinternational\.com|eurocard\.com|eurocard\.dk|eurocard\.fi|eurocard\.no|globecard\.dk|partnermastercard\.com|saseurobonusmastercard\.dk|saseurobonusmastercard\.no|saseurobonusmastercard\.se|sebgroup\.com|sebkort\.com|seb\.se|wallethome\.com|spendwise\.se))[^/\s]+[a-zA-Z0-9._-]/gi
            }, {
              name: 'TEL',
              regex: /((tel=)|(telephone=)|(phone=)|(mobile=)|(mob=))[\d+\s][^&/?]+/gi
            }, {
              name: 'NAME',
              regex: /((firstname=)|(lastname=)|(surname=))[^&/?]+/gi
            }, {
              name: 'PASSWORD',
              regex: /((password=)|(passwd=)|(pass=))[^&/?]+/gi
            }, {
              name: 'ZIP',
              regex: /((postcode=)|(zipcode=)|(zip=))[^&/?]+/gi
            }, {
              name: 'SOCIAL SECURITY NUMBER',
              regex: /(\d{6}|\d{8})[-|(\s)]{0,1}\d{4}/gi
            }];
            if (val) {
              piiRegEx.forEach(function(pii) {
                val = val.replace(pii.regex, '[REDACTED ' + pii.name + ']');
              });
            }
          } catch (exception) {
            // console.error('PII fail: ' + exception);
          }
          return val;
    }


    static saveOriginalReferrerAsCookie(value) {
        const analyticalCookiesApproved =
            value['cookies-groups'].filter((group) => group.name === 'analyticalcookies')[0].approved;
        if (analyticalCookiesApproved) {
            const referrer = document.referrer; // test a value with query string here
            const linkParts = referrer.split('?');
            let referrerNoPersonalData = linkParts[0];
            if (linkParts.length > 1) {
                referrerNoPersonalData += '?' + CookieConsentApi.getStringWithoutPersonalData(linkParts[1])
            }
            Cookies.saveJSON(CookieConsentApi.cookieTrackFirstVisit, {
                referrer: referrerNoPersonalData,
            }, '', value.domain);
        } else {
            Cookies.remove(CookieConsentApi.cookieTrackFirstVisit, value.domain);
        }
    }

    /** @param {import('./def/CookieConsent').CookieConsentCookie} value The cookie consent value */
    static save(value) {
        const domainNoPort = window.location.host.replace(/:[0-9]+/gi, '');
        if (typeof value.domain === 'undefined') {
            console.warn('Domain should be set from BE cookie, if this is the styleguide ignore this message');
            value.domain = domainNoPort;
        }
        Cookies.saveJSON(
            CookieConsentApi.cookieConsentKey,
            value,
            CookieConsentApi.cookieConsentDaysToExpire,
            value.domain
        );
        CookieConsentApi.saveOriginalReferrerAsCookie(value);
    }
}

export default CookieConsentApi;